"use strict";

// import axios from "axios";
import store from "@/store/index";
import { UtentesListRow, DB, initDB } from '../dbClass';
import { errorFuncStruct, conection } from './conectionUtils';
import { nl2br } from './utils';

export interface UtenteForm {
  id: number | null;
  nome: string;
  telefone: string;
  codigo: string;
  observacoes: string;
}

export interface UtenteTotalCards{
  id: number;
  nome: string;
  nome_pesquisa: string;
  telefone: string;
  codigo: string;
  cartoes: number;
  cartoes_dados: {id: number; diagnostico: string; diagnostico_pesquisa: string; tratamento: string; tratamento_pesquisa: string}[];
  diagnosticos: string;
  diagnosticos_pesquisa: string;
}

function truncateUtentesDB(cbOk: () => void): void{
  let db: DB = store.getters.db;
  db = initDB(db);

  db.utenteslist.clear()
    .then(() => {
      cbOk();
    })
    .catch((error) => {
      throw new Error(error);
    });
}

function addUtentesDB(
  utentes: Array<UtentesListRow>,
  cbOk: (utentes: Array<UtentesListRow>) => void
): void{
  let db: DB = store.getters.db;
  db = initDB(db);

  db.utenteslist.bulkAdd(utentes)
    .then( () => {
      cbOk(utentes);  
    })
    .catch((error) => {
      throw new Error(error);
    });
}


export function getUtentesServer(
  cbOk: (utentes: Array<UtentesListRow>) => void,
  cbError: errorFuncStruct
){
  conection(
    "getUtentes.php",
    {},
    (rBody) => {
      const utentesServer: Array<UtentesListRow> = rBody.utentes as Array<UtentesListRow>;
      truncateUtentesDB(() => {
        addUtentesDB(
          utentesServer,
          cbOk
        )
      });
    },
    cbError
  );
}


export function getAllUtentesServer(
  cbOk: (utentes: UtenteTotalCards[]) => void,
  cbError: errorFuncStruct
){
  conection(
    "getAllUtentes.php",
    {},
    (resp: {utentes: UtenteTotalCards[]}) => {
      cbOk(resp.utentes);
    },
    cbError
  );
}

export function getUtentesDB(cb: (u: UtentesListRow[]) => void){
  let db: DB = store.getters.db;
  db = initDB(db);

  const utentes: UtentesListRow[] = [];
  db.utenteslist.each(item => {
    utentes.push(item);
  })
  .then(item => {
    if(item == undefined){
      cb(utentes);
    }
  })
}

export function newUtenteServer(
  utente: UtenteForm,
  cbOk: () => void,
  cbError: errorFuncStruct
) {
  conection(
    "newUtente.php",
    {utente: utente},
    cbOk,
    cbError
  );
}

// export function updateUtenteServer(
//   utente: UtenteForm,
//   cbOk: () => void,
//   cbError: errorFuncStruct
// ) {
//   conection(
//     "newUtente.php",
//     {utente: utente},
//     cbOk,
//     cbError
//   );
// }

export interface Iutente{
  id: number;
  nome: string;
  telefone: string | null;
  codigo: string | null;
  observacoes: string | null;
  date_inserted: string | null;
  date_updated: string | null;
}

export class Utente {
  private utenteBD: Iutente;
  constructor(utente: Iutente) {
    this.utenteBD = utente;
  }

  get nome(): string{
    return this.utenteBD.nome;
  }

  get observacoes(): string{
    if(this.utenteBD.observacoes){
      return nl2br(this.utenteBD.observacoes, false);
    }
    else {
      return "";
    }
  }

  get utenteForm(): UtenteForm{
    const utente: UtenteForm = {
      id: this.utenteBD.id,
      codigo: this.utenteBD.codigo ? this.utenteBD.codigo : "",
      nome: this.utenteBD.nome,
      observacoes: this.utenteBD.observacoes ? this.utenteBD.observacoes : "",
      telefone: this.utenteBD.telefone ? this.utenteBD.telefone : ""
    };
    return utente;
  }
}

// export function getUtenteInfo(
//   id: number,
//   cbOk: (rBody: responseUtente) => void,
//   cbError: errorFuncStruct
// ): void{
//   conection("getUtente.php",{id: id}, cbOk, cbError);
// }